	<div class="header-container" matDialogTitle>
		<button mat-button [mat-dialog-close]="uploadType.None" color="primary">
			<mat-icon>arrow_back</mat-icon>
			Back
		</button>
		<h1 style="margin: 0px !important">Add a Product</h1>
	</div>

	<mat-dialog-content>
		<mat-radio-group [(ngModel)]="selectedUploadType">
			<div class="card-container">
				<div class="card">
					<div class="radio-button-container">
						<mat-radio-button [value]="uploadType.Single" color="primary">
						</mat-radio-button>
					</div>
					<h5>Upload single product</h5>
					<p>
						Start from scratch and set limits for time, location, and other
						parameters to customize your Xpress for Business settings.
					</p>
				</div>
				<div class="card">
					<div class="radio-button-container">
						<mat-radio-button [value]="uploadType.Multiple" color="primary">
						</mat-radio-button>
					</div>
					<h5 color="primary">Upload multiple products</h5>
					<p>
						Start from scratch and set limits for time, location, and other
						parameters to customize your Xpress for Business settings.
					</p>
				</div>
			</div>
		</mat-radio-group>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button
			mat-flat-button
			color="primary"
			class="mr-2 mb-2"
			[disabled]="selectedUploadType === uploadType.None"
			[mat-dialog-close]="selectedUploadType"
			cdkFocusInitial
		>
			Next
		</button>
	</mat-dialog-actions>
